import { createFileRoute, redirect } from '@tanstack/react-router'

import { postLoginRedirect } from '@/shared/auth/post-login-redirect'
import { useAuthStore } from '@/shared/auth/stores/authStore'

// Root URL — bounces to /login when signed out, otherwise to the
// role's home page (admin/super_admin → /entities, HOD → /hod/dashboard,
// FO → /mobile-only).
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const state = useAuthStore.getState()
    if (!state.isAuthenticated) {
      throw redirect({ to: '/login' })
    }
    throw redirect({ to: postLoginRedirect(state.user?.role_name) })
  },
})
